// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class PlanningBudgetEntry {
  readonly id: string;
  readonly plantId: string;
  readonly planningPeriodId: string;
  readonly planningProductId: string;
  readonly tons: string;
  readonly asp: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.plantId = data.plantId === undefined ? NIL_UUID : data.plantId;
    this.planningPeriodId = data.planningPeriodId === undefined ? NIL_UUID : data.planningPeriodId;
    this.planningProductId =
      data.planningProductId === undefined ? NIL_UUID : data.planningProductId;
    this.tons = data.tons === undefined ? '0' : data.tons;
    this.asp = data.asp === undefined ? null : data.asp;
  }

  static zero(): PlanningBudgetEntry {
    const zeroValues: ExcludeMethodsDeep<PlanningBudgetEntry> = {
      id: NIL_UUID,
      plantId: NIL_UUID,
      planningPeriodId: NIL_UUID,
      planningProductId: NIL_UUID,
      tons: '0',
      asp: null,
    };
    return new PlanningBudgetEntry(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PlanningBudgetEntryWireFormat = {
  id: string;
  plantId: string;
  planningPeriodId: string;
  planningProductId: string;
  tons: string;
  asp: string | null;
};

type NewPlanningBudgetEntryProps = PartialDeep<PlanningBudgetEntry, { recurseIntoArrays: true }>;
export const NewPlanningBudgetEntry: (props: NewPlanningBudgetEntryProps) => PlanningBudgetEntry = (
  props,
) => new PlanningBudgetEntry(props);

type NewPlanningBudgetEntryFromWireFormatProps = PartialDeep<
  PlanningBudgetEntryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewPlanningBudgetEntryFromWireFormat: (
  props: NewPlanningBudgetEntryFromWireFormatProps,
) => PlanningBudgetEntry = (props) => new PlanningBudgetEntry(props);
